import { useContext } from 'react';
import { UserFeatureContext } from '../components/contexts/UserFeatureContext';

/**
 * Hook that determines whether a given feature is enabled
 * @param {*} featureName Feature name key.
 */
export default function useFeature(featureName) {
  const { activeFeatures } = useContext(UserFeatureContext);

  if (!featureName) {
    console.error('Illegal Arguments passed to useFeature.');
    return false;
  }

  if (!activeFeatures) {
    console.error(
      `Unable to determine if feature: ${featureName} exists due to missing context values.`
    );
    return false;
  }

  const featureIndex = activeFeatures.findIndex(
    feature => feature.featureName === featureName
  );

  // Requested featureName does not exist in set of active features.
  if (featureIndex < 0) {
    return false;
  }

  return activeFeatures[featureIndex].enabled;
}
